import * as sqtAxiosConfig from '@client/axios/sqt.axiosConfig'

const axiosInstance = sqtAxiosConfig.getNewInstance(`${global.SEQITRACKER_API_URL}/finance`, { exclude: { paths: ['/reports'] } });

const clearCache = async function () {
  await axiosInstance.cache.clear();
}

const generateVerrechenbarReport = async function (from, to) {
  return (await axiosInstance.get(`/reports/verrechenbar?from=${from}&to=${to}`, {
    headers: {
      'accept': global.HTTP_HEADER.ACCEPT.TEXTCSV
    }
  })).data;
}


export {
  generateVerrechenbarReport,
  clearCache
}